 const ServiceType = {
    SINGLE: 'single',
    SHEET: 'sheet'
  }
export default ServiceType;
